<template>
   <div class="switch-hold-header">
      <div class="container">
         <div class="content">
            <div class="tick-container">
               <div class="tick"></div>
            </div>

            <div>
               <h1>Processing Switch</h1>

               <p>
                  We will process your switch with your new supplier <b>{{ supplierName }}</b> one day before your
                  completion date. Your completion date is <b>{{ completionDate }}</b>.
                  Once the switch has been submitted, you will receive an email notification confirming this.
                  Please check your spam or junk folder, as sometimes messages can be filtered there.
               </p>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'SwitchHoldHeader',
   props: {
      supplierName: String,
      referenceNumber: String,
      completionDate: String
   }
};
</script>

<style lang="scss">
.switch-hold-header {
   background-color: $brand-colour-primary;
   padding: 40px 0 30px 0;
   margin: 0 0 30px 0;
   color: #fff;

   h1 {
      font-size: 40px;
      margin: 0;
      line-height: 1.2;
      color: #fff;
   }

   p {
      font-size: 20px;
      color: #fff;
   }

   .content {
      position: relative;
      padding: 0 0 0 115px;
   }

   .tick-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100px;
      height: 100px;
      background-color: darken($brand-colour-primary, 10%);
      border-radius: 50%;

      .tick {
         position: absolute;
         left: 0;
         top: 0;
         right: 0;
         bottom: 0;
         margin: auto;
         width: 32px;
         height: 24px;
         background: url('../../../assets/tick.png') no-repeat;
         background-size: contain;
         background-position: 100% 0;
      }
   }

   @media (max-width: 767px) {
      .content {
         position: relative;
         padding: 0 0 0 90px;
      }

      .tick-container {
         width: 70px;
         height: 70px;
      }
   }
}
</style>
